// extracted by mini-css-extract-plugin
module.exports = {"mb_sm":"style_mb_sm__IF1tj","icon":"style_icon__V8Zis","value":"style_value__69kQl"};